module.exports = __webpack_public_path__ + "img/bell_3.577e60d3.jpg";